'use client'

import type { HTMLProps } from 'react'
import clsx from 'classnames'
import { useLocale } from 'use-intl'
import { Text } from '@/shared/ui'
import { IEventCategory } from '@/interfaces/events'
import { formatter, getDateLabel } from '@/shared/utils'
import { TagEvent } from '@/shared/ui/tag-event'
import style from './article-header.module.scss'

type ArticleHeaderProps = HTMLProps<HTMLDivElement> & {
  date: string
  category: IEventCategory
  light?: boolean
  location: string
  ageRestriction: number | null
}

export const ArticleHeader = ({ className, category, date, location, ageRestriction }: ArticleHeaderProps) => {
  const currentLocale = useLocale()
  return (
    <header className={clsx(style.header, className)}>
      <TagEvent className={clsx(style.label, 'text_color_dark')} color={category.color}>
        {category.name}
      </TagEvent>
      {date && (
        <Text className={style.label} type="d" tagName="span" color="dark-040">
          {getDateLabel({ date, locale: currentLocale })}
        </Text>
      )}
      {location && (
        <Text className={clsx(style.label, style.location)} type="d" tagName="span" color="dark-040">
          {location}
        </Text>
      )}
      {ageRestriction && (
        <Text className={clsx(style.label, style.ageRestriction)} type="d" tagName="span" color="dark-040">
          {ageRestriction}+
        </Text>
      )}
    </header>
  )
}
